var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompanyuser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 14,
    viewBox: "0 0 22 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2778 3.19338C13.2778 4.44895 12.2555 6.63786 11 6.63786C9.7444 6.63786 8.72217 4.44525 8.72217 3.18597C8.74588 2.59824 8.99604 2.04247 9.42027 1.63501C9.8445 1.22755 10.4099 1 10.9981 1C11.5863 1 12.1517 1.22755 12.576 1.63501C13.0002 2.04247 13.2504 2.59824 13.2741 3.18597L13.2778 3.19338Z",
    stroke: "#0676B5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.31152 13.0454C6.31152 11.8018 6.80554 10.6091 7.68488 9.72978C8.56423 8.85044 9.75688 8.35642 11.0005 8.35642C12.2441 8.35642 13.4367 8.85044 14.3161 9.72978C15.1954 10.6091 15.6894 11.8018 15.6894 13.0454",
    stroke: "#0676B5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9598 4.70083C18.9598 5.7638 18.0968 7.66382 17.0339 7.66382C15.9709 7.66382 15.1079 5.74899 15.1079 4.70083C15.1079 4.18954 15.311 3.6992 15.6725 3.33767C16.0341 2.97613 16.5244 2.77303 17.0357 2.77303C17.547 2.77303 18.0373 2.97613 18.3989 3.33767C18.7604 3.6992 18.9635 4.18954 18.9635 4.70083H18.9598Z",
    stroke: "#0676B5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6333 9.9342C15.2225 9.48822 15.9244 9.2155 16.6601 9.14674C17.3959 9.07797 18.1362 9.21589 18.7978 9.54496C19.4594 9.87404 20.0161 10.3812 20.4051 11.0094C20.7942 11.6376 21.0002 12.362 21 13.1009",
    stroke: "#0676B5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.04081 4.70083C3.04081 5.7638 3.90379 7.66382 4.96676 7.66382C6.02974 7.66382 6.89271 5.74899 6.89271 4.70083C6.89271 4.18954 6.6896 3.6992 6.32807 3.33767C5.96654 2.97613 5.47619 2.77303 4.96491 2.77303C4.45362 2.77303 3.96328 2.97613 3.60175 3.33767C3.24022 3.6992 3.03711 4.18954 3.03711 4.70083H3.04081Z",
    stroke: "#0676B5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.36674 9.9342C6.77757 9.48822 6.07563 9.2155 5.3399 9.14674C4.60417 9.07797 3.86385 9.21589 3.20224 9.54496C2.54063 9.87404 1.98397 10.3812 1.59491 11.0094C1.20585 11.6376 0.999819 12.362 1 13.1009",
    stroke: "#0676B5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyuser);
export default __webpack_public_path__ + "static/media/companyuser.75f87ffdeee88819f23e51aa06fe15bf.svg";
export { ForwardRef as ReactComponent };